import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, asyncToGenerator as _asyncToGenerator, classCallCheck as _classCallCheck, callSuper as _callSuper, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { hasAccess, hasFeatureEnabled } from '../utils/AccessControlUtil.js';
/**
 * Shows/hides or displays alternate content based on whether a set
 * of conditions is met.  If more than one set of conditions is provided,
 * then all conditions must pass to show the content
 */

var AccessControlWrapper = /*#__PURE__*/function (_Component) {
  function AccessControlWrapper(props) {
    var _this;

    _classCallCheck(this, AccessControlWrapper);

    _this = _callSuper(this, AccessControlWrapper, [props]);

    _defineProperty(_this, "hasAccess", function () {
      return hasAccess(_this.props) && _this.hasFeatureEnabled();
    });

    _defineProperty(_this, "hasFeatureEnabled", function () {
      return _this.state.featureEnabled;
    });

    _this.state = {
      featureEnabled: !props.flag
    };
    return _this;
  }

  _inherits(AccessControlWrapper, _Component);

  return _createClass(AccessControlWrapper, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$props, flag, adminifiUrl, authToken, featureEnabled;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, flag = _this$props.flag, adminifiUrl = _this$props.adminifiUrl, authToken = _this$props.authToken;

                if (!flag) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return hasFeatureEnabled(flag, adminifiUrl, authToken);

              case 4:
                featureEnabled = _context.sent;
                this.setState({
                  featureEnabled: featureEnabled
                });
                _context.next = 9;
                break;

              case 8:
                this.setState({
                  featureEnabled: true
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (this.hasAccess()) {
        return this.props.children;
      }

      return this.props.alternateContent || null;
    }
  }]);
}(Component);

_defineProperty(AccessControlWrapper, "propTypes", {
  /** feature props */
  flag: PropTypes.string,
  adminifiUrl: PropTypes.string,
  authToken: PropTypes.string,

  /** generic value required to view content */
  // requiredValue: PropTypes.oneOfType([
  //   PropTypes.string, PropTypes.arrayOf(PropTypes.string)
  // ]),

  /** permission required to view content (taken from admin) */
  // requiredPermission: PropTypes.string,

  /** business line required to view content - if array only one needs
  to match (taken from user if provided, otherwise taken from organization) */
  // requiredBusinessLine: PropTypes.oneOfType([
  //   PropTypes.string, PropTypes.arrayOf(PropTypes.string)
  // ]),

  /** capability required to view content (taken from organization) */
  // requiredCapability: PropTypes.string,

  /** organizationType required to view content (taken from organization) */
  // requiredOrganizationType: PropTypes.oneOf(['advanced', 'basic']),

  /** values available */
  // values: PropTypes.arrayOf(PropTypes.string),

  /** permissions available */
  // permissions: PropTypes.arrayOf(PropTypes.string),

  /** business lines available */
  // businessLines: PropTypes.arrayOf(PropTypes.string),

  /** capabilities available */
  // capabilities: PropTypes.arrayOf(PropTypes.string),

  /** organization type */
  // organizationType: PropTypes.oneOf(['advanced', 'basic']),

  /** will search admin for permissions */
  admin: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string)
  }),

  /** will search user for businessLines */
  user: PropTypes.shape({
    business_lines: PropTypes.arrayOf(PropTypes.string)
  }),

  /** will search org for capabilities/organization_type */
  organization: PropTypes.shape({
    capability_list: PropTypes.arrayOf(PropTypes.string),
    organization_type: PropTypes.oneOf(['advanced', 'basic'])
  }),

  /** renders children if flipper check passes */
  children: PropTypes.node,

  /** renders alternateContent if flipper check fails */
  alternateContent: PropTypes.node
});

AccessControlWrapper.displayName = "AccessControlWrapper";
export { AccessControlWrapper };